import WarningIcon from '@mui/icons-material/Warning';
import { Container, Stack, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import styled from 'styled-components';
import variable from '../shared/style/variable';
import { cleanAlert } from '../store/alert/alertSlice';
import { useAppDispatch } from '../store/hook';
import { cleanProject } from '../store/project/projectSlice';
import { cleanResult } from '../store/result/resultSlice';
import { cleanImage } from '../store/Image/imageSlice';

const ErrorBoundaryContainer = styled(Container)`
    padding: 0;
    flex-grow: 1;
    margin-top: 1rem;
`;

const ErrorBoundary = () => {
    let error = useRouteError();
    console.log(error);

    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    React.useEffect(() => {
        dispatch(cleanProject());
        dispatch(cleanResult());
        dispatch(cleanImage());
        dispatch(cleanAlert());
    }, []);

    return (
        <ErrorBoundaryContainer maxWidth='md'>
            <Stack flexGrow={1} direction={'column'} margin={'4rem 0'} alignItems={'center'} spacing={2}>
                <WarningIcon style={{ height: '5rem', width: '5rem', fill: variable.red }} />
                <Typography variant='h1' style={{ color: variable.green }} gutterBottom>
                    {t('oopsSomethingWentWrong')}
                </Typography>
            </Stack>
        </ErrorBoundaryContainer>
    );
};

export default ErrorBoundary;
